<div class="modal-header">
  <h4 id="equipmnt-compare-modal" class="modal-title">{{ "Compare" | translate }}</h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <table class="table table-striped comparison-table">
    <tbody>
      <tr *ngFor="let prop of rows[0]; let i = index" [class]="prop.propertyName.toLowerCase()">
        <th>
          <ng-container *ngIf="prop.propertyName !== EquipmentItemDisplayProperty.IMAGE">
            {{ prop.name }}
          </ng-container>
        </th>
        <ng-container *ngFor="let row of rows">
          <td [class.na]="row[i].value === null || row[i].value === ''">
            <span [innerHTML]="row[i].value || 'n/a' | translate"></span>
            <span *ngIf="row[i].propertyName !== EquipmentItemDisplayProperty.IMAGE" class="edit-button">
              <fa-icon
                *ngIf="showEditButton(row[i])"
                (click)="editButtonClicked(row[i].klass, row[i].id)"
                icon="pen"
              ></fa-icon>
            </span>
          </td>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Close" | translate }}
  </button>
</div>
